import React from 'react';
import PropTypes from 'prop-types';
import ProgressiveImage from '../ProgressiveImage/ProgressiveImage';
import './ArticleHero.less';

const ArticleHero = (props) => {
    const {title, image, renderedCrumbs} = props;

    return (
        <div className="ArticleHero">
            <div className="ArticleHero__image">
                {image && (
                    <ProgressiveImage
                        src={image.url}
                        alt="article hero"
                        fit="fill"
                        critical
                    />
                )}
            </div>
            <div className="ArticleHero__content-container">
                <div className="ArticleHero__content article-content-container">
                    {renderedCrumbs}
                    <h1 className="ArticleHero__title" itemProp="headline">
                        {title}
                    </h1>
                </div>
            </div>
        </div>
    );
};

ArticleHero.propTypes = {
    title: PropTypes.string.isRequired,
    image: PropTypes.objectOf(PropTypes.string),
    renderedCrumbs: PropTypes.node,
};

export default ArticleHero;
